/**
 * Die Problemsignale je Projekt für die Badges hinter dem Projektnamen. `reload` nach einer Änderung an Terminen – die Badges bleiben dabei stehen.
 */
import { useCallback, useEffect, useState } from "react";
import { deadlinesApi } from "../../../../services/api/deadlines";
import { ProjectSignals } from "../../../../types";

export const useProjectSignals = (enabled: boolean) => {
  const [signals, setSignals] = useState<Record<string, ProjectSignals>>({});

  const reload = useCallback(async () => {
    if (!enabled) return;
    try {
      const result = await deadlinesApi.getSignals();
      setSignals(Object.fromEntries(result.map((s) => [s.project_id, s])));
    } catch {
      // Ohne Signale bleibt die Tabelle, wie sie ist – sie sind ein Hinweis, keine Pflicht.
    }
  }, [enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { signals, reload };
};
